module.exports = __webpack_public_path__ + "static/media/grand-tour-logo.40554ca9.png";